module.exports = __webpack_public_path__ + "img/Ariel.f0249ffa.jpg";